/**
 * Created by AlexanderC on 6/25/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let UUID_REGEXP = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

/**
 * Fixes weird joi exception!
 *
 * @param {Object} proto
 * @returns {Object}
 * @private
 */
function _joiVector(proto) {
  let arr = _joi2.default.array();

  if (arr.includes) {
    return arr.includes(proto);
  }

  return arr.items(proto);
}

exports.default = typeof window !== 'undefined' ? {
  types: {
    uuid: function uuid() {
      return _joi2.default.string().regex(UUID_REGEXP);
    },

    timeUUID: function timeUUID() {
      return _joi2.default.string().regex(UUID_REGEXP);
    },

    stringSet: function stringSet() {
      return _joiVector(_joi2.default.string());
    },

    numberSet: function numberSet() {
      return _joiVector(_joi2.default.number());
    },

    binarySet: function binarySet() {
      return _joiVector(_joi2.default.string());
    }
  }
} : require('vogels');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/Helpers/vogelsPolyfill.js
// module id = 463
// module chunks = 0